import debug = require('debug');
import { none, some } from 'fp-ts/lib/Option';
import { setGlobalInfoDuration } from 'qa/src/events/app';
import {
    changeGlobalNoteText,
    deleteGlobalNoteText,
    setFilterCriticality,
} from 'qa/src/events/qa';
import {
    getGlobalInfoDuration,
    getRenderGlobalInfoBlock,
} from 'qa/src/queries/app';
import {
    getGlobalNoteText,
    getNbCriticity,
    getNbNewIssues,
} from 'qa/src/queries/qa';
import { DIV, SPAN } from 'sdi/components/elements';
import tr from 'sdi/locale';
import { Duration } from 'qa/src/events/route';
import { renderEditableText } from '../editable-text';
import { setTableTitle } from 'qa/src/events/table';

const logger = debug('client:global-info');

const isDurationActive = (duration: Duration) =>
    getGlobalInfoDuration() === duration ? 'active' : 'inactive';

export const renderDurationSelect = () =>
    DIV(
        {
            className: `tab-title-switch`,
        },
        SPAN(
            {
                className: `tab-title week ${isDurationActive('week')}`,
                onClick: () => setGlobalInfoDuration('week'),
            },
            `${tr.qa('week')} `
        ),
        SPAN(
            {
                className: `tab-title month ${isDurationActive('month')}`,
                onClick: () => setGlobalInfoDuration('month'),
            },
            `${tr.qa('month')} `
        ),
        SPAN(
            {
                className: `tab-title year ${isDurationActive('year')}`,
                onClick: () => setGlobalInfoDuration('year'),
            },
            `${tr.qa('year')} `
        )
    );

const renderMainNumber = () =>
    DIV(
        {
            className: `global-field main-number`,
            key: `global-field-main-number`,
        },
        DIV({ className: 'global-field-value' }, getNbNewIssues()),
        DIV({ className: 'global-field-text' }, tr.qa('newIssues'))
    );

const renderCriticalityNumbers = () =>
    DIV(
        {
            className: `global-field criticality-number`,
            key: `global-field-criticality-number`,
        },
        DIV(
            {
                className: 'criticality-value high',
                onClick: () => {
                    setFilterCriticality('high');
                    setTableTitle(
                        `${tr.qa('filteredByCriticality')}: ${tr.qa(
                            'high'
                        )} / ${tr.qa('new')}`
                    );
                },
            },
            SPAN({ className: 'criticality-nb-value' }, getNbCriticity('high')),
            SPAN(
                { className: 'criticality-text-value link-simple' },
                tr.qa('high')
            )
        ),
        DIV(
            {
                className: 'criticality-value medium',
                onClick: () => {
                    setFilterCriticality('medium');
                    setTableTitle(
                        `${tr.qa('filteredByCriticality')}: ${tr.qa(
                            'medium'
                        )} / ${tr.qa('new')}`
                    );
                },
            },
            SPAN(
                { className: 'criticality-nb-value' },
                getNbCriticity('medium')
            ),
            SPAN(
                { className: 'criticality-text-value link-simple' },
                tr.qa('medium')
            )
        ),
        DIV(
            {
                className: 'criticality-value low',
                onClick: () => {
                    setFilterCriticality('low');
                    setTableTitle(
                        `${tr.qa('filteredByCriticality')}: ${tr.qa(
                            'low'
                        )} / ${tr.qa('new')}`
                    );
                },
            },
            SPAN({ className: 'criticality-nb-value' }, getNbCriticity('low')),
            SPAN(
                { className: 'criticality-text-value link-simple' },
                tr.qa('low')
            )
        )
    );

const renderGlobalNote = () =>
    DIV(
        { className: `issue-field note`, key: `global-field-note` },
        // DIV({ className: 'issue-field-label' }, tr.qa('notes')),
        // getNoteEditStatus() ? renderGlobalEditableNote() : renderGlobalReadonlyNote()
        renderEditableText(
            'notes',
            'global',
            changeGlobalNoteText,
            getGlobalNoteText,
            deleteGlobalNoteText
        )
    );

const renderGlobalInfo = () =>
    DIV(
        { className: 'global-info-page' },
        DIV({ className: 'global-info-content-top' }, renderMainNumber()),
        renderCriticalityNumbers()
        // renderGlobalNote(),
    );

export const renderGlobalInfoOpt = () =>
    getRenderGlobalInfoBlock() ? some(renderGlobalInfo()) : none;

export const renderGlobalNoteOpt = () =>
    getRenderGlobalInfoBlock() ? some(renderGlobalNote()) : none;

logger('loaded');
